import keyBy from 'lodash/keyBy';
import {
  MODAL_DISPLAY_TEXT_FOR_DELETING_CAMPAIGNS,
  MODAL_DISPLAY_TEXT_FOR_DELETING_FOLDER,
} from 'modules/campaignIndex/constants';
import { useEffect } from 'react';
import { DeleteItemsModal } from 'ui/indexPages/modals/DeleteItemsModal';
import { isSelectionContent, isSelectionFolder } from 'utils/contexts/selection';
import noOp from 'utils/noop';

import { useCampaignQueryContext } from '../campaignFolders/contexts/CampaignQueryContext';
import { useSelectionContext } from '../campaignFolders/contexts/SelectionContext';
import { useCampaignFolderModals } from '../hooks/useCampaignFolderModals';
import { useDeleteCampaignsAndFolders } from '../hooks/useDeleteCampaignsAndFolders';

export const DeleteFolderModal = () => {
  const { refetch } = useCampaignQueryContext();
  const { active, clearAll } = useSelectionContext();
  const modals = useCampaignFolderModals();

  const [deleteTemplateContentsAndFolders] = useDeleteCampaignsAndFolders({
    onComplete: () => {
      modals.delete.toggle(false);
    },
    onError: noOp,
    onSuccess: () => {
      refetch();
    },
    // @ts-expect-error
    itemsById: keyBy(active, 'id'),
  });

  useEffect(() => {
    return () => {
      // when an item gets set through the actions, we need to clear it on the way out
      clearAll();
    };
  }, []);

  const seletedContent = active.filter(isSelectionContent);
  const selectedFolders = active.filter(isSelectionFolder);

  const deleteItems = () => {
    const contentIds = seletedContent.map((c) => c.id);
    const folderIds = selectedFolders.map((c) => c.id);

    deleteTemplateContentsAndFolders({
      variables: {
        contentIds,
        folderIds,
      },
    });
  };

  return (
    <DeleteItemsModal
      onClose={() => modals.delete.toggle(false)}
      onConfirm={deleteItems}
      displayTextForContentItems={
        selectedFolders.length > 1
          ? MODAL_DISPLAY_TEXT_FOR_DELETING_CAMPAIGNS
          : MODAL_DISPLAY_TEXT_FOR_DELETING_FOLDER
      }
      content={seletedContent}
      folders={selectedFolders}
    />
  );
};
